import React from "react";
import { Modal } from "../Components/Elements/Modal";
import { Menu } from "../Components/Elements/Menu";
import { Container as ContainerUI } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppTitle } from "../Hooks/useAppTitle";
import { AppBarPublic } from "../Components/AppBars/AppBarPublic";
import { ThemeModeProvider } from "./ThemeProvider";
import { Footer } from "../Components/Elements/Footer";

const LayoutProvider = ({ children, layout, fullWidth }) => {

    const app = useSelector(state => state.app);
    useAppTitle(app.config?.app_name || 'DGTIA: Tools');

    const getLayout = (layout) => {

        switch (layout) {
            case 'AUTH':
                return AuthLayout;
            case 'PUBLIC':
                return PublicLayout;
            default:
                return undefined;
        }
    };

    const selectedLayout = getLayout(layout);

    if (!selectedLayout) {
        return <>{children}</>;
    }

    return selectedLayout({ children, fullWidth });
};

const AuthLayout = ({ children }) => {
    return (
        <ThemeModeProvider layoutType="AUTH">
            <ContainerUI
                sx={{
                    height: '100vh',
                    p: '0!important',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                component="main"
                maxWidth={"xxl"}
            >
                {children}
            </ContainerUI>
        </ThemeModeProvider>
    );
};

const PublicLayout = ({ children }) => {

    return (
        <ThemeModeProvider layoutType="PUBLIC">
            <AppBarPublic />
            {children}
            <Modal />
            <Footer />
        </ThemeModeProvider>
    )
}

export default LayoutProvider;
